<footer>
    <p-button *ngIf="!displayQuickMenu" styleClass="fixed z-2 shadow-6 hover:shadow-8" [style]="{bottom: '5%', right: '2%'}" size="large" 
        [rounded]="true" (onClick)="showQuickMenu()" ariaLabel="Menú de accesos rápidos">
        <p-image src="assets/images/flame.png" width="35px" height="37.53" alt="Menú de páginas llamativas"></p-image>
    </p-button>
    <p-dialog [(visible)]="displayQuickMenu" [position]="'bottomright'" [dismissableMask]="true" [draggable]="false" styleClass="w-8 sm:w-5">
        <ng-template pTemplate="content">
            <div class="flex flex-column sm:flex-row align-items-center sm:justify-content-around gap-5">
                <a [routerLink]="getUrl(url['nuevas'])" class="p-button no-underline shadow-4 hover:shadow-6" (click)="hideQuickMenu()">
                    <i class="pi pi-star-fill p-1"></i> Recien llegadas
                </a>
                <a [routerLink]="getUrl(url['recomendadas'])" class="p-button no-underline" (click)="hideQuickMenu()">
                    <i class="pi pi-heart-fill p-1"></i> Recomendadas
                </a>
            </div>
        </ng-template>
        <ng-template pTemplate="closeicon">
            <i class="pi pi-times text-4xl"></i>
        </ng-template>
    </p-dialog>
    <div class="flex flex-column align-items-center gap-5">
        <img ngSrc="assets/images/main-logo-white.png" width="247" height="50" class="mt-5" alt="Logo de MuyComplacientes" priority="true"  />
        <div class="flex flex-row gap-3 align-items-center justify-content-center w-11 m-auto">
            <a [routerLink]="url['acerca-de']" title="Acerca de">Acerca de</a>
            <a [routerLink]="url['terminos']" title="Terminos de uso">Términos de uso</a>
            <a [routerLink]="url['contactanos']" title="Contacto">Contacto</a>
            <!--<a [routerLink]="url['aliados']" title="Aliados">Aliados</a>-->
            <!--<a [routerLink]="url['blog']">Blog</a>
            <p class="text-white">Blog</p>-->
            <a href="https://www.rtalabel.org" rel="nofollow noopener" target="_blank" title="RTA">
                <img ngSrc="assets/images/RTA.gif" alt="RTA logo" width="60" height="30" loading="lazy" />
            </a>
        </div>
        <div class="flex flex-row gap-3">
            <i class="pi pi-facebook text-white" style="font-size: 1.5rem"></i>
            <i class="pi pi-twitter text-white" style="font-size: 1.5rem"></i>
            <i class="pi pi-instagram text-white" style="font-size: 1.5rem"></i>
            <i class="pi pi-youtube text-white" style="font-size: 1.5rem"></i>
        </div>
        <p class="text-white">2025 Reservados todos los derechos</p>
    </div>
</footer>